export class AddAlbumsToTagModel {
  id: number;
  name: string;
  artist: string;
  imageUrl: string;
  hasTag: boolean;
}
